export default {
  label: '初级程序员',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '刚进入行业的新手，负责基础代码实现。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '负责编写和维护代码，处理简单项目，完成基础的技术任务，如数据处理和系统功能实现。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '掌握基础编程语言和开发工具，了解应用程序生命周期和数据库服务。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通过积累经验，逐步晋升为中级程序员或高级程序员。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪在6,000元至10,000元之间。',
          id: '0-5-1',
        },
      ],
    },
  ],
};